export default "__VITE_ASSET__vmmzenRg__"